import React from "react";

const articles = [
  {
    title: "Comment LinkedIn peut accélérer votre développement commercial",
    date: "28 juin 2025",
    image: "/images/blog/image-01.jpg",
    excerpt:
      "Découvrez comment nos clients utilisent LinkedIn pour générer des leads qualifiés, renforcer leur visibilité et créer des opportunités business concrètes.",
    link: "/blog/linkedin-business",
  },
  {
    title: "Stratégies de marque employeur qui font la différence",
    date: "18 juin 2025",
    image: "/images/blog/image-02.jpg",
    excerpt:
      "La guerre des talents est lancée. Apprenez à attirer les bons profils en valorisant votre culture d’entreprise sur LinkedIn.",
    link: "/blog/marque-employeur-linkedin",
  },
  {
    title: "Le personal branding du dirigeant : un levier sous-estimé",
    date: "12 juin 2025",
    image: "/images/blog/image-03.jpg",
    excerpt:
      "Les dirigeants qui s’expriment sur LinkedIn humanisent leur entreprise et attirent la confiance. Voici comment le faire efficacement.",
    link: "/blog/personal-branding-dirigeant",
  },
];

const BlogPreviewSection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <span className="text-primary text-lg font-semibold mb-2 block">Nos derniers articles</span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900">Conseils, tendances & retours d'expérience</h2>
          <p className="text-gray-600 mt-4">
            Boostez votre stratégie LinkedIn avec nos articles experts.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {articles.map((article, index) => (
            <a key={index} href={article.link} className="block bg-gray-50 rounded-lg overflow-hidden shadow-sm hover:shadow-md transition">
              <img src={article.image} alt={article.title} className="w-full h-48 object-cover" />
              <div className="p-5">
                <h3 className="text-lg font-semibold text-gray-800">{article.title}</h3>
                <p className="text-sm text-gray-500 mb-2">{article.date}</p>
                <p className="text-sm text-gray-700">{article.excerpt}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogPreviewSection;
